<div id="surveyCreator">
    <survey-creator [model]="surveyCreatorModel"></survey-creator>
  </div>